import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, Space, Card, Select, Row, Col, Flex } from 'antd';
import StoreSettingService from "services/store_setting";
import ImagePicker from "components/pickers/image/MultiImagePicker"
import ThemeSetting from "components/pickers/theme-setting"
import { CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useForm, useWatch } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import ProductsPicker from './ProductsPicker';
import _ from "lodash"




const ProductBlock = ({ data, onChange, onDelete }) => {



    return (
        <>

            <Form.Item
                label="Kiểu"
                name="display"
                rules={[{ required: true, message: 'Please input your website!' }]}

            >
                <Select options={[{ label: "Slide", value: "carousel" }, { label: "Slide nhỏ", value: "carousel_small" }]} style={{ width: "100%" }} > </Select>
            </Form.Item>



            <Form.Item
                label="Hình ảnh"
                name="images"
                rules={[{ required: true, message: 'Please input your website!' }]}

            >
                <ImagePicker></ImagePicker>
            </Form.Item>


        </>

    )
}
export default ProductBlock;